<template>
  <div class="currency-select-wrap">
    <select-2
      class="w-full currency-select-field"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      :options="selectOptions"
      autocomplete
      :ssr="false"
      :clearable="false"
      @input="onInput"
    />
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { getCurrencySymbol } from '@/utils/currency'

export default {
  name: 'CurrencySelect',

  components: { Select2 },

  props: {
    value: {
      type: String,
      default: 'INR'
    },
    options: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: 'service-currency'
    },
    placeholder: {
      type: String,
      default: 'Search currency (code or name)'
    }
  },

  computed: {
    selectOptions() {
      return (this.options || []).map((c) => {
        const symbol = c.symbol || getCurrencySymbol(c.code)
        return {
          value: c.code,
          label: `${c.code} — ${c.name} (${symbol})`
        }
      })
    }
  },

  methods: {
    onInput(item) {
      const code = item && item.value ? item.value : item
      if (code) {
        this.$emit('input', code)
      }
    }
  }
}
</script>

<style scoped>
.currency-select-wrap {
  width: 100%;
}

.currency-select-field >>> .input-select,
.currency-select-field >>> .vs-select--input {
  min-height: 42px;
  font-size: 14px;
}

.currency-select-field >>> .con-select {
  width: 100%;
}
</style>
